<section class="gb_sectionPosizioniNOcodiceavviso">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="gb_textarea">
          <div class="gb_textarea">
            <h2 class="gb_h3">{{ "aree-tematiche" | translate }}</h2>
            <p class="gb_p" [innerHtml]="'aree-tematiche-descrizione' | translate | safeHtml"></p>
            <!-- TODO: F015 - utilizzare il routerLink quando i servizi lato BE sono pronti -->
            <!-- <a routerLink="/{{authorityId}}/personal/thematic-area" class="gb_btncta w u" -->
            <a href="#" class="gb_btncta w u disabled"
              [title]="'vai-al-servizio' | translate" tabindex="0"
              attr.aria-label="{{ 'vai-al-servizio' | translate }}">{{ "vai-al-servizio" | translate }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
